<template>
  <div class="el-card">
    <div class="el-card__image" v-if="$slots.image || image">
      <slot name="image">{{ image }}</slot>
    </div>
    <div class="el-card__header" v-if="$slots.header || header && $slots.actions || actions">
      <div class="flex">
        <div class="title" v-if="$slots.header || header">
          <slot name="header">{{ header }} </slot><small v-if="$slots.subtitle"><slot name="subtitle">{{subtitle}}</slot></small>
        </div>
        <div class="actions" v-if="$slots.actions || actions">
          <slot name="actions">{{ actions }}</slot>
        </div>
      </div>
    </div>
    <div class="el-card__body" :style="bodyStyle">
      <slot></slot>
    </div>
    <div class="el-card__footer" v-if="$slots.footer || footer">
      <slot name="footer">{{ footer }}</slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ElCard',
  props: ['header', 'subtitle', 'actions', 'image', 'bodyStyle', 'footer'],
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/variables';

.el-card {
  margin-bottom: 20px;
  &__header{
    font-weight: bold;
    background-color: #f9f9f9;
    .flex{
      display: flex;
      width: 100%;
      >div{
        flex: 1;
        &.title{
          small{
            color: #888;
          }
        }
        &.actions{
          text-align: right;
          a{
            color: $--saffron-red-delight;
          }
        }
      }
    }
    .el-button{
      padding: 5px 15px;
      float: right;
    }
    .icon{
      color: #ababab;
      padding: 0px 10px 0px 0px;
    }
  }
  &__image {
    img {
      max-width: 100%;
    }
  }
  &__footer {
      padding: 18px 20px;
      border-top: 1px solid #ebeef5;
      box-sizing: border-box;
      overflow: hidden;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ElCard.vue